import React, { useState } from "react";
import { useApp } from "@/context/AppContext";
import { KeyRound, LogOut } from "lucide-react";

export default function ForcePwChange() {
  const { user, changePassword, logout } = useApp();
  const [cur, setCur] = useState("");
  const [np, setNp] = useState("");
  const [cp, setCp] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [ok, setOk] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (np.length < 6) { setError("नवीन पासवर्ड किमान ६ अक्षरांचा असावा."); return; }
    if (np !== cp) { setError("नवीन पासवर्ड व पुष्टीकरण जुळत नाही."); return; }
    setBusy(true);
    try {
      await changePassword(cur, np);
      setOk(true);
    } catch (err) {
      setError(err.message || "पासवर्ड बदल अयशस्वी.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#f6f2e6] p-4">
      <div className="w-full max-w-md rounded-2xl border border-[#e6dcc4] bg-white p-7 shadow-sm" data-testid="force-pw-change">
        <div className="mb-2 flex items-center gap-2 text-[#1b5e3f]"><KeyRound className="h-5 w-5" /><h1 className="font-head text-[22px] font-medium">पासवर्ड बदलणे आवश्यक</h1></div>
        <p className="mb-5 text-[13px] text-slate-500">
          खाते <span className="font-latin font-semibold text-[#1b3d2a]">{user?.username || user?.email}</span> साठी पुढे जाण्यापूर्वी नवीन पासवर्ड निश्चित करणे आवश्यक आहे. सध्याचा (किंवा रीसेट केलेला तात्पुरता) पासवर्ड टाका.
        </p>
        {ok ? (
          <div className="rounded-lg border border-emerald-200 bg-emerald-50 p-4 text-center text-[14px] font-semibold text-emerald-700" data-testid="force-pw-success">
            पासवर्ड यशस्वीरित्या बदलला. काही क्षणात पुढे नेले जात आहे...
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-3">
            <div>
              <label className="mb-1 block text-[13px] font-semibold text-slate-700">सध्याचा / तात्पुरता पासवर्ड</label>
              <input type="password" value={cur} onChange={(e) => setCur(e.target.value)} required data-testid="force-pw-current"
                className="w-full rounded-lg border border-slate-300 px-3 py-2.5 text-[14px] outline-none focus:border-[#1b5e3f]" />
            </div>
            <div>
              <label className="mb-1 block text-[13px] font-semibold text-slate-700">नवीन पासवर्ड (किमान ६ अक्षरे)</label>
              <input type="password" value={np} onChange={(e) => setNp(e.target.value)} required data-testid="force-pw-new"
                className="w-full rounded-lg border border-slate-300 px-3 py-2.5 text-[14px] outline-none focus:border-[#1b5e3f]" />
            </div>
            <div>
              <label className="mb-1 block text-[13px] font-semibold text-slate-700">नवीन पासवर्ड पुन्हा टाइप करा</label>
              <input type="password" value={cp} onChange={(e) => setCp(e.target.value)} required data-testid="force-pw-confirm"
                className="w-full rounded-lg border border-slate-300 px-3 py-2.5 text-[14px] outline-none focus:border-[#1b5e3f]" />
            </div>
            {error && <p className="text-[13px] font-semibold text-red-600" data-testid="force-pw-error">{error}</p>}
            <button type="submit" disabled={busy} data-testid="force-pw-submit"
              className="w-full rounded-full bg-[#1b5e3f] py-3 text-[15px] font-semibold text-white hover:bg-[#144d33] disabled:opacity-60">
              {busy ? "बदलत आहे..." : "पासवर्ड बदला व पुढे जा"}
            </button>
            <button type="button" onClick={logout} data-testid="force-pw-logout"
              className="flex w-full items-center justify-center gap-1.5 py-1 text-[13px] font-semibold text-slate-500 hover:text-[#1b5e3f]">
              <LogOut className="h-4 w-4" /> लॉगआउट
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
